import React, { useEffect, useState } from "react";

import {
    Box,
    CircularProgress,
    Paper,
    Stack,
    TextField,
    Button,
    Typography
} from "@mui/material";
import { CHANGE_REQUEST_URL } from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import { ThemeProvider } from "../../v2/home/theme/ThemeProvider";

const CommentsTab = ({
    change
}) => {

    const [comments, setComments] =
        useState([]);

    const [comment, setComment] =
        useState("");

    const [loading, setLoading] =
        useState(true);

    const [saving, setSaving] =
        useState(false);


    const loadComments = async () => {

        try {

            const response =
                await AxiosInstance.get(
                    `${CHANGE_REQUEST_URL}/${change.id}/comments`
                );

            setComments(
                response.data?.data ||
                response.data ||
                []
            );

        } catch (error) {

            console.error(
                "Unable to load comments",
                error
            );

        } finally {

            setLoading(false);
        }
    };


    useEffect(() => {

        if (change.id) {
            loadComments();
        }

    }, [change.id]);


    const addComment = async () => {

        if (!comment.trim()) {
            return;
        }

        setSaving(true);

        try {

            await AxiosInstance.post(
                `/api/changes/${change.id}/comments`,
                {
                    comment: comment.trim()
                }
            );

            setComment("");

            await loadComments();

        } catch (error) {

            console.error(
                "Unable to add comment",
                error
            );

        } finally {

            setSaving(false);
        }
    };


    return (

        <Box>

            <Typography
                variant="h6"
                fontWeight={600}
                sx={{ mb: 2 }}
            >
                Comments
            </Typography>


            <Stack
                direction={{
                    xs: "column",
                    md: "row"
                }}
                spacing={2}
                mb={3}
            >
                <ThemeProvider>
                    <TextField
                        fullWidth
                        multiline
                        minRows={2}
                        label="Add Comment"
                        value={comment}
                        onChange={(e) =>
                            setComment(
                                e.target.value
                            )
                        }
                    />
                </ThemeProvider>
                <Button
                    variant="contained"
                    onClick={addComment}
                    disabled={
                        saving ||
                        !comment.trim()
                    }
                >
                    Add
                </Button>

            </Stack>


            {loading ? (

                <CircularProgress />

            ) : comments.length === 0 ? (

                <Typography
                    color="text.secondary"
                >
                    No comments yet.
                </Typography>

            ) : (

                <Stack spacing={2}>

                    {comments.map(
                        item => (

                            <Paper
                                key={item.id}
                                variant="outlined"
                                sx={{ p: 2 }}
                            >

                                <Typography
                                    fontWeight={600}
                                >
                                    {
                                        item.createdByName ||
                                        item.createdBy ||
                                        "User"
                                    }
                                </Typography>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        mt: 1,
                                        whiteSpace:
                                            "pre-wrap"
                                    }}
                                >
                                    {
                                        item.comment
                                    }
                                </Typography>

                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                >
                                    {
                                        item.createdOn ||
                                        ""
                                    }
                                </Typography>

                            </Paper>

                        )
                    )}

                </Stack>

            )}

        </Box>
    );
};


export default CommentsTab;